import { useState } from 'react';

const ContactModal = ({ isOpen, onClose }) => {
  const sellers = [
    { name: 'Karen Quezada', area: 'Zona Francas', whatsapp: '18098199043', email: 'ventas1@rmcomponentes.com' },
    { name: 'Loraina Castro',area: 'Revendedores', whatsapp: '8297078450', email: 'ventas2@rmcomponentes.com' },
    { name: 'Alaicha Cruz',area: 'Zona Francas y Revendedores ', whatsapp: '8295398643', email: 'ventas3@rmcomponentes.com' },
  ];

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl p-8 w-full max-w-lg relative transform scale-95 animate-scaleIn">
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 transition-colors"
        >
          <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        
        <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">Cotizar Ahora</h2>
        <p className="text-gray-700 mb-8 text-center">Elige a tu vendedor/a o contáctanos por correo:</p>

        <div className="space-y-6">
          {sellers.map((seller, index) => (
            <div key={index} className="bg-gray-100 p-5 rounded-lg flex flex-col md:flex-row items-center justify-between shadow-sm">
              <div className="flex flex-col items-center md:items-start mb-3 md:mb-0">
                <span className="font-semibold text-gray-800 text-lg">{seller.name}</span>
                {seller.area && (
                  <span className="text-sm text-gray-500">{seller.area}</span>
                )}
              </div>
              <div className="flex space-x-4">
                <a 
                  href={`https://wa.me/${seller.whatsapp}`} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-full flex items-center transition-colors transform hover:scale-105"
                >
                  <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24"><path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.5 3.45 1.46 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21 5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2zm3.58 14.87c-.16.27-.6.52-.89.55-.29.02-.66.1-.99-.12-.33-.21-1.17-.39-2.3-.79-1.4-.5-2.36-1.87-2.63-2.29-.27-.42-.03-.64.19-.85.18-.17.4-.4.59-.6.19-.2.26-.39.39-.65.13-.26.07-.49-.04-.69-.11-.2-.3-.48-.42-.72-.12-.25-.24-.2-.33-.2-.08 0-.17-.01-.26-.01-.09 0-.24.03-.37.18-.13.15-.5.49-.5.99s.51 1.15.58 1.23c.07.08 1 1.59 2.42 2.17 1.42.58 1.77.41 2.1.38.33-.03.89-.36 1.05-.66.17-.3.17-.56.12-.66-.05-.1-.19-.15-.39-.24z"/></svg>
                  WhatsApp
                </a>
                <a 
                  href={`mailto:${seller.email}`} 
                  className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-full flex items-center transition-colors transform hover:scale-105"
                >
                  <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
                  Correo
                </a>
              </div>
            </div>
            
          ))}
        </div>
      </div>
    </div>
  );
};
export default ContactModal;